import { ArrowRight } from "lucide-react";
import { ArticleCard } from "../../components/activities/ArticleCard";
import type { ArticleGridComponent } from "../../types";
import { RuntimeLink } from "../../runtime/RendererRuntime";
import { resolveLinkHref } from "../../utils/links";

/** Article grid renderer. The optional call-to-action ("Voir tout") renders
 *  BELOW the grid, centered — the section reads cards-first, then the
 *  "see all" action that opens the full listing (e.g. /articles). */
export function ArticleGridRenderer({ component }: { component: ArticleGridComponent }) {
  const { items, ctaHref, ctaLabel } = component.content;
  const resolvedCtaHref = resolveLinkHref(ctaHref);
  return (
    <section>
      <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
        {items.map((a, i) => (
          <ArticleCard key={`${a.title}-${i}`} {...a} />
        ))}
      </div>
      {resolvedCtaHref && ctaLabel ? (
        <div className="mt-8 flex justify-center">
          <RuntimeLink
            href={resolvedCtaHref}
            className="group inline-flex items-center gap-2 rounded-full bg-[#FFC105] px-5 py-2.5 text-sm xl:text-base font-semibold text-white shadow-sm transition hover:bg-[#E0A800]"
            aria-label={ctaLabel}
          >
            {ctaLabel}
            <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
          </RuntimeLink>
        </div>
      ) : null}
    </section>
  );
}


